import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "h2" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row py-0 align-content-md-center" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "mt-0 pl-3" }
const _hoisted_8 = { class: "mt-0 pl-3" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "mt-0 pl-3" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "mt-0 pl-3" }
const _hoisted_14 = { class: "mt-0 pl-3" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "mt-0 pl-3" }
const _hoisted_17 = { class: "mt-0 pl-3" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "row py-6" }
const _hoisted_20 = { class: "col-12 px-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "force-page-break" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_MethodSelection = _resolveComponent("MethodSelection")!
  const _component_MainResults = _resolveComponent("MainResults")!
  const _component_MainResultsGHG = _resolveComponent("MainResultsGHG")!
  const _component_PartialResults = _resolveComponent("PartialResults")!
  const _component_PartialResultsGHG = _resolveComponent("PartialResultsGHG")!
  const _component_Scope3Results = _resolveComponent("Scope3Results")!
  const _component_ResultsESG = _resolveComponent("ResultsESG")!
  const _component_HighestEmissionResults = _resolveComponent("HighestEmissionResults")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, { showCalculationRow: "" }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_1, [
            _createVNode(_component_SimpleText, { "text-key": "results.headerTitle" }),
            _createTextVNode(" " + _toDisplayString(_ctx.calculation.calculationPurpose.name) + ": ", 1),
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.doPrettify(_ctx.totalEmission)) + " ", 1),
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString("results.tonCo2")]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_RichText, { "text-key": "results.headerText" })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_SharedHeader, {
      useOneColumn: "true",
      "header-padding": "py-4"
    }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h6", _hoisted_7, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.calculation" })
              ]),
              _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.calculation.calculationPurpose?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h6", _hoisted_10, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.period" })
              ]),
              _withDirectives((_openBlock(), _createElementBlock("h5", {
                "aria-live": "polite",
                "aria-label": _ctx.formatDates(_ctx.calculation.calculationPurpose.startDate, _ctx.calculation.calculationPurpose.endDate) || _ctx.missingContent,
                class: "mt-0 pl-3"
              }, [
                _createTextVNode(_toDisplayString(_ctx.formatDates(_ctx.calculation.calculationPurpose.startDate, _ctx.calculation.calculationPurpose.endDate) || _ctx.missingContent), 1)
              ], 8, _hoisted_11)), [
                [_directive_dompurify_html, _ctx.formatDates(_ctx.calculation.calculationPurpose.startDate, _ctx.calculation.calculationPurpose.endDate) || _ctx.missingContent]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h6", _hoisted_13, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.country" })
              ]),
              _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.country), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h6", _hoisted_16, _toDisplayString(_ctx.emissionCoefficientTitle), 1),
              _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.getCoefficientVersionYear), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_MethodSelection, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_21,
          _createVNode(_component_MainResults, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_22,
          _createVNode(_component_MainResultsGHG, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_23,
          _createVNode(_component_PartialResults, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_24,
          _createVNode(_component_PartialResultsGHG, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_25,
          _createVNode(_component_Scope3Results, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_26,
          _createVNode(_component_ResultsESG, {
            printMode: true,
            results: _ctx.results
          }, null, 8, ["results"]),
          _hoisted_27,
          _createVNode(_component_HighestEmissionResults, {
            behalfOfVatNr: _ctx.behalfOfVatNr,
            printMode: true,
            results: _ctx.results
          }, null, 8, ["behalfOfVatNr", "results"])
        ])
      ])
    ])
  ], 64))
}